import React, { useContext, useEffect, useRef, useState } from "react";
import { useParams, useSearchParams, useLocation } from "react-router-dom";
import Client3D, { Client3DProps } from "../../lib/three";
import ClientFabric from "../../lib/fabric"
import http from '../../lib/http'
import * as apis from '../../lib/apis'
import Menu, { Action as MenuAction } from './plugins/menu'
import Loading from "./plugins/loading";
import Plugins from './plugins'
import Context from './context'
import pluginsContext from './plugins/context'
import { Button, Toast, Drag, FixedNav } from '@nutui/nutui-react';
import { Events } from '../home/plugins/action_title'
import { Height as CutpartHeight } from './plugins/cutpart'
import { Height as InfoHeight, Bottom as InfoBottom } from './plugins/info'
import { Height as HeadHeight } from './plugins/head'
import * as THREE from 'three';

const fclients = new Map()
const threeclients = new Map()

var temp3DheightCache: any = {}
var needHideTitle = false

const Index = (props: any) => {
    const params: any = useParams()
    const [searchParams] = useSearchParams();
    const canvasRef = useRef<HTMLCanvasElement>(null)
    const [detailData, setDetailData] = useState<any>({ materials: { cutparts: [] } })
    const [detailAllData, setDetailAllData] = useState<any>({})
    const [curCutpartCode, setCurCutpartCode] = useState("")
    const [curCanvasClient, setCurCanvasClient] = useState<any>()
    const [curThreeClient, setCurThreeClient] = useState<any>()
    const [fabricClient, setFabricClient] = useState<any>(null) //fabric句柄
    const [threeClient, setThreeClient] = useState<Client3D>() //3D句柄
    const [controPosition, setControPosition] = useState<any>()
    const [editMode, setEditMode] = useState<any>()
    const [fabricW, setFabricW] = useState<number>()
    const [menuHeight, setMenuHeight] = useState<number>()
    const [curActivityObject, setCurActivityObject] = useState<any>()
    const [subMenuMode, onSubMenuMode] = useState<number>()
    const [showTitle, setShowTitle] = useState<boolean>(true)
    const [safeHeigth, setSafeHeigth] = useState<number>(-1)
    const [progress, setProgress] = useState<number>(0)
    const [objectModified, setObjectModified] = useState(0)
    const [previewMode, setPreViewMode] = useState<boolean>(false)
    const [visibleFixedNav, setVisibleFixedNav] = useState(false);
    const [curFabric, setCurFabric] = useState<any>({})
    const [action3D, setAction3D] = useState<any>({})
    const [ossClient, setOssClient] = useState({})
    const [curEvent, setCurEvent] = useState<Events>()

    const is_preview = searchParams.get("is_preview");
    const design_model_id = searchParams.get("design_model_id");
    const designId = params.id;
    const product_id = searchParams.get("product_id");

    const location = useLocation();
    const [externalData, setExternalData] = useState<any>(location.state?.designData);
    const [isExternalMode, setIsExternalMode] = useState(!!location.state?.designData);
    const [windowSize, setWindowSize] = useState({
        width: window.innerWidth,
        height: window.innerHeight
    });

    const safeHeightRef: any = useRef()
    const menuRef: React.MutableRefObject<MenuAction | undefined> = useRef()

    const threeClientRef: any = useRef()
    const urlParams = new URLSearchParams(useLocation().search);
    const design_id = urlParams.get("design_id");
    const tc = useContext(Context)

    //当code改变时，失去焦点
    useEffect(() => {
        curCanvasClient?.discardActiveObject()
        threeclients.get(curCutpartCode)?.activate()
    }, [curCutpartCode, curCanvasClient])
    //title滑动
    const titleChange = async (code: string, d = detailData) => {
        const fclient = fclients.get(code)
        if (!fclient) return
        const tclient = threeclients.get(code)
        if (!tclient) return

        let f = d?.model_materials?.cutparts?.find((i: any) => i.code === code)
        setCurCutpartCode(code)
        setCurCanvasClient(fclient)
        setCurThreeClient(tclient)
        if (f?.camera) {
            threeClientRef?.current?.setCamera(f.camera.x, f.camera.y, f.camera.z)
        }
        // await fclient.addImageById("https://file-1254182580.cos.ap-beijing.myqcloud.com/2021-12-10/1639141117721.png",300)
        // tclient.needsUpdate(500)
        return true
    }

    //更新当前更新模式
    const onEditMode = (mode: string) => {
        setEditMode(mode)
    }
    useEffect(() => {
        if (is_preview === "1" && threeClient) {
            const initPreview = async () => {

                // 等待布局稳定
                await new Promise(resolve => setTimeout(resolve, 200));

                // 使用和手动点击相同的逻辑
                preview3D();
            };

            // 延迟执行，确保页面完全加载
            setTimeout(() => {
                initPreview();
            }, 1000);
        } else {
            const initPreview = async () => {
                threeClient?.setCanvasSize(document.body.clientWidth, document.body.clientHeight)
            };

            // 延迟执行，确保页面完全加载
            setTimeout(() => {
                initPreview();
            }, 1000);

        }
    }, [is_preview, threeClient]);
    //预览3D
    const preview3D = () => {
        temp3DheightCache.height = threeClient?.getCanvasDom()?.clientHeight
        if (showTitle) {
            needHideTitle = true
            setShowTitle(false)
        }
        threeClient?.setCanvasSize(document.body.clientWidth, document.body.clientHeight)
        setPreViewMode(true)
    }

    //退出预览3D
    const quitPreview3D = () => {
        if (needHideTitle) {
            setShowTitle(true)
        }
        threeClient?.setCanvasSize(document.body.clientWidth, temp3DheightCache.height)
        needHideTitle = false
        setPreViewMode(false)
    }

    //面料切换
    const fixedNavOnChange = (e: any) => {
        setVisibleFixedNav(e)
    }

    //选择面料
    const choiceFabric = async (v: any, a: any, b: any) => {
        if (v.color === curFabric.color) {
            return
        }
        try {
            let cli: any
            if (a) {
                cli = a
            } else {
                cli = action3D
            }
            if (v.codes_info && v.codes_info.length !== 0) {
                for (let i = 0; i < v.codes_info.length; i++) {
                    let item = v.codes_info[i]
                    if (item.maps) {
                        cli.clearMap(item.code)
                    }
                }
            }
            if (v.codes_info && v.codes_info.length !== 0) {
                for (let i = 0; i < v.codes_info.length; i++) {
                    let item = v.codes_info[i]
                    if (item.maps) {
                        for (let j = 0; j < item.maps.length; j++) {

                            let jitem = item.maps[j]

                            // await cli.setMap(jitem.url, jitem.map, item.code)
                            await cli.openRepeat(item.code, true)
                            await cli.setMapOffset(item.code, -0.5, -0.5)
                            await cli.setMapRepeat(item.code, 1, 1)
                        }
                    }
                }
            }
            setCurFabric(v)
        } catch (error) {
            Toast.fail(t("底色加载失败"))
        }
    }

    const sleep = (time: any) => {
        return new Promise((resolve: any, reject) => {
            setTimeout(() => {
                resolve()
            }, time)
        })
    }

    const getCanvasDom = async (code: string): Promise<HTMLElement | null> => {
        let c = document.getElementById(code)

        if (!c) {
            await sleep(100)
            return await getCanvasDom(code)
        }
        return c
    }

    useEffect(() => {
        const fetchData = async () => {
            try {
                const apiPath = apis.DATA_DETAIL;
                const params = {
                    ...(product_id && { product_id }),
                    ...(design_id && { design_id }) //设计模块
                };

                const data = await http.get(`${apiPath}/${designId}`, { params });

                await initializeDesign(data);

            } catch (error) {
                console.error(error);
                Toast.fail(t("加载失败"));
            }
        };
        fetchData();


    }, [designId, product_id, design_id, externalData, isExternalMode]);
    const initializeDesign = async (data: any) => {
        if (!data) return;
        try {
            // 彻底清理之前的画布和状态
            if (threeClientRef.current) {
                threeClientRef.current.destroy();
                threeClientRef.current = null;
            }

            // 清理所有 fabric 画布
            fclients.forEach((client, key) => {
                try {
                    const canvas = client.getFabricCanvas();
                    canvas.dispose(); // 彻底销毁 fabric 画布
                } catch (error) {
                    console.warn(`清理画布 ${key} 时出错:`, error);
                }
            });

            // 清空所有缓存
            fclients.clear();
            threeclients.clear();

            // 重置相关状态
            setThreeClient(undefined);
            setFabricClient(null);
            setAction3D(null);
            setCurActivityObject(null);
            let ops: Client3DProps = {
                canvasDom: canvasRef?.current as HTMLCanvasElement,
                canvasWidth: window.innerWidth,  // 直接用窗口宽度
                canvasHeight: window.innerHeight - 15 // 简单调整
            }
            let client: Client3D = new Client3D(ops);
            setThreeClient(client);
            threeClientRef.current = client;
            client.start();

            const fabricClient = new ClientFabric();
            setFabricClient(fabricClient);
            fabricClient?.cacheAllData()
            // 处理数据格式
            data.model_materials = JSON.parse(data.model_materials);
            let materialsData = data;

            window.document.title = data.model_name;
            setDetailData(materialsData);
            setDetailAllData(data);
            // 加载3D模型
            let modelData = materialsData?.model_materials;
            const action3D: any = await client.loadModel(modelData.obj_url, (p: number) => {
                setProgress(p);
            });

            setAction3D(action3D);
            Object.keys(action3D.object3Dchilds).forEach((meshName, index) => {
                const mesh = action3D.object3Dchilds[meshName];
                if (mesh.material && mesh.material.type === 'MeshPhongMaterial') {
                    // 动态查找对应mesh的法线贴图
                    let normalMapUrl = null;
                    if (modelData?.map_info) {
                        for (const mapInfo of modelData.map_info) {
                            const codeInfo = mapInfo.codes_info?.find((code: any) => code.code === meshName);
                            if (codeInfo) {
                                const normalMap = codeInfo.maps?.find((map: any) => map.map === 'normalMap');
                                if (normalMap) {
                                    normalMapUrl = normalMap.url;
                                    break;
                                }
                            }
                        }
                    }
                    // 只在没有法线贴图时创建新材质
                    if (normalMapUrl && !mesh.material.normalMap) {
                        const newMaterial = new THREE.MeshPhongMaterial({
                            normalMap: new THREE.TextureLoader().load(normalMapUrl),
                            normalScale: new THREE.Vector2(0.3, 0.3),
                            color: mesh.material.color,
                            side: THREE.DoubleSide,
                        });
                        mesh.material = newMaterial;
                    }

                }
            });
            // 初始化所有fabric画布
            let materialData = materialsData?.model_materials?.cutparts

            for (let i = 0; i < materialData.length; i++) {
                let item = materialData[i];
                const fclient = fabricClient.loadCanvas(item.code);
                fclients.set(item.code, fclient);

                const cdom: any = await getCanvasDom(item.code);

                const tclient = action3D.setMapCanvasTextureByName(item.code, cdom as HTMLCanvasElement);

                threeclients.set(item.code, tclient);
                // 回显文字照片背景处理
                if (materialsData?.designer_config_url) {
                    loadSavedTextToCanvas(fclient, item.code, materialsData);
                }

                fclient?.onCanvas((e: any, controPosition: any, event: string) => {
                    if (event === "after:render") {
                        const acObj = fclient.getFabricCanvas().getActiveObject();
                        if (acObj) {
                            setCurActivityObject(acObj);
                        } else {
                            setCurActivityObject(null);
                        }
                        tclient.needsUpdate();
                        setControPosition(controPosition);

                    }
                    if (event === "object:modified") {
                        setObjectModified(new Date().getTime());

                    }
                });
                // 数据加载完成后，延迟清空控制状态
                setTimeout(() => {
                    setCurActivityObject(null);
                    // 初始化加载数据的时候不展示控制按钮
                    setControPosition(null);
                }, 100);
            }
            // 设置UI相关
            const menuHeight = menuRef.current?.getHeight!() as number;
            setMenuHeight(menuHeight);
            const goldenRatio = document.body.clientHeight * 0.5;
            const w = document.body.clientHeight - goldenRatio - CutpartHeight - safeHeightRef.current.clientHeight - 80
            //设置裁片高度
            fabricClient.setWidth(w)
            setFabricW(w);
            console.log(w, "w")
            setSafeHeigth(safeHeightRef.current.clientHeight);
            // client.setCanvasSize(window.innerWidth - document.body.clientWidth, window.innerHeight - 15);
            const canvas3DHeight = document.body.clientHeight - InfoHeight - menuHeight - InfoBottom - HeadHeight
            client.setCanvasSize(document.body.clientWidth, canvas3DHeight)

            // 设置面料和标题
            if (modelData?.map_info && modelData?.map_info?.length !== 0) {
                choiceFabric(modelData?.map_info[0], action3D, fabricClient);
                const textureLoader = new THREE.TextureLoader();
                const normalTexture = await new Promise<THREE.Texture>((resolve) => {
                    textureLoader.load(modelData.map_info[0].codes_info[0].maps[0].url, resolve);
                })
                // 遍历 action3D.object3Dchilds 中的每个子对象
                Object.keys(action3D.object3Dchilds).forEach((meshName, index) => {
                    if (action3D.object3Dchilds[meshName].material) {
                        // 复制 result1 中的材质到 result2 中
                        if (modelData.map_info[0].codes_info[index].code === meshName) {
                            action3D.object3Dchilds[meshName].material.normalMap = normalTexture;
                            action3D.object3Dchilds[meshName].material.normalScale.set(0.3, 0.3);
                            action3D.object3Dchilds[meshName].material.needsUpdate = true
                            // 调整vector2
                            action3D.object3Dchilds[meshName].material.normalMap.repeat.set(1, 1);
                        }
                    }
                });
            }
            if (modelData.cutparts && modelData.cutparts.length !== 0) {
                titleChange(modelData.cutparts[0].code, data);
            }

        } catch (error) {
            console.error("初始化设计失败:", error);
            Toast.hide();
            Toast.fail(t("加载失败"));
            throw error;
        }
    };

    const loadSavedTextToCanvas = async (canvasClient: any, cutpartCode: string, materialsData: any) => {
        if (!materialsData?.designer_config_url) return;
        const response = await fetch(materialsData?.designer_config_url);
        const jsonData = await response.json();
        try {
            const canvas = canvasClient.getFabricCanvas();
            const savedCanvasData = jsonData.canvas_data?.find((v: any) => v.code === cutpartCode);
            if (savedCanvasData?.data) {
                await canvasClient.loadDataFromJson(savedCanvasData.data);
                canvas.clear();
                canvas.set('backgroundColor', savedCanvasData.data.background);
                canvas.renderAll();

                const match = savedCanvasData?.data?.background?.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)/);
                if (match) {
                    const r = parseInt(match?.[1]);
                    const g = parseInt(match?.[2]);
                    const b = parseInt(match?.[3]);
                    // 将RGB转换为十六进制
                    const hex = `#${((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1)}`;
                    (threeClientRef.current as any)?.scene?.traverse((child: any) => {
                        if (child.isMesh && child.material) {

                            if (child?.material) {
                                if (child?.material.name === cutpartCode) {
                                    child.material.color = new THREE.Color(hex);
                                } else if (child?.material?.name === "" && child?.name === cutpartCode) {
                                    child.material.color = new THREE.Color(hex);
                                }
                            }
                        }
                    });
                }
                // 分别处理文字和图片
                const objects = savedCanvasData.data.objects || [];
                const textObjects = objects.filter((obj: any) => obj.type === 'text');
                const imageObjects = objects.filter((obj: any) => obj.type === 'image');
                const pathObjects = objects.filter((obj: any) => obj.type === 'path');
                // 加载照片
                const imagePromises = imageObjects.map(async (imageData: any) => {
                    try {
                        const imageObject = await canvasClient.addImageById(imageData.src, 580 * 0.5);
                        if (imageObject) {
                            return new Promise((resolve) => {
                                if (imageObject.isNotLoaded !== undefined && imageObject.isNotLoaded) {
                                    imageObject.on('loaded', () => {
                                        applyImageProperties(imageObject, imageData, canvas);
                                        resolve(true);
                                    });
                                } else {
                                    applyImageProperties(imageObject, imageData, canvas);
                                    resolve(true);
                                }
                            });
                        }
                    } catch (error) {
                        console.error(`加载图片失败:`, error);
                        return Promise.resolve(false);
                    }
                });
                await Promise.all(imagePromises);
                // 加载文字
                textObjects.forEach((textData: any) => {
                    const textObject = canvasClient.addText(textData.text);
                    if (textObject) {
                        textObject.left = textData.left;
                        textObject.top = textData.top;
                        textObject.fontSize = textData.fontSize;
                        textObject.fontFamily = textData.fontFamily;
                        textObject.fill = textData.fill;
                        textObject.fontWeight = textData.fontWeight;
                        textObject.fontStyle = textData.fontStyle;
                        textObject.opacity = textData.opacity;
                        textObject.angle = textData.angle;
                        textObject.scaleX = textData.scaleX;
                        textObject.scaleY = textData.scaleY;
                        canvas.renderAll();

                    }
                });
                // 加载涂鸦 - 手动创建 fabric.Path
                const fabricInstance = (window as any).fabric;
                pathObjects.forEach((pathData: any) => {
                    try {
                        const path = new fabricInstance.Path(pathData.path, {
                            fill: pathData.fill || 'transparent',
                            stroke: pathData.stroke || '#000000',
                            strokeWidth: pathData.strokeWidth || 2,
                            strokeLineCap: pathData.strokeLineCap || 'round',
                            strokeLineJoin: pathData.strokeLineJoin || 'round',
                            opacity: pathData.opacity || 1,
                            selectable: true,
                            evented: true,
                        });

                        // 设置位置和变换属性
                        path.set({
                            left: pathData.left,
                            top: pathData.top,
                            scaleX: pathData.scaleX,
                            scaleY: pathData.scaleY,
                            angle: pathData.angle,
                            originX: pathData.originX || 'left',
                            originY: pathData.originY || 'top',
                        });

                        // 设置坐标
                        if (typeof path.setCoords === 'function') {
                            path.setCoords();
                        }

                        canvas.add(path);

                    } catch (error) {
                        console.error('涂鸦回显失败:', error, pathData);
                    }
                });
                fabricClient?.isEmptyAll()
            }
            Toast.hide()
        } catch (error) {
            console.error(`加载对象到画布 ${cutpartCode} 失败:`, error);
        }
    };


    const applyImageProperties = (imageObject: any, imageData: any, canvas: any) => {
        imageObject.left = imageData.left || 10;
        imageObject.top = imageData.top || 10;
        imageObject.scaleX = imageData.scaleX || 1;
        imageObject.scaleY = imageData.scaleY || 1;
        imageObject.angle = imageData.angle || 0;
        imageObject.opacity = imageData.opacity || 1;
        imageObject.originX = imageData.originX || 'left';
        imageObject.originY = imageData.originY || 'top';

        if (typeof imageObject.setCoords === 'function') {
            imageObject.setCoords();
        }
    };

    return (
        <div style={{
            background: "linear-gradient(180deg, rgba(238,238,238,0) 0%, #CCCCCC 100%)",
            height: "100vh"
        }}>
            <div className="a" style={{ display: (detailData?.model_materials?.map_info && detailData?.model_materials?.map_info?.length > 1) ? "block" : "none" }}>
                <Drag direction="y" style={{ right: '0px', top: "20vh", zIndex: "999!important" }}>
                    <FixedNav
                        onChange={fixedNavOnChange}
                        visible={visibleFixedNav}
                        // navList={navList}
                        unActiveText={t('选择颜色')}
                        activeText={t('收起颜色')}
                        slotList={
                            <div className="nut-fixednav__list" slot="list" style={{ width: detailData?.model_materials?.map_info?.length * 25 || 0, marginRight: 8 }}>
                                {
                                    detailData?.model_materials?.map_info?.map((v: any) => (
                                        <div onClick={async () => {
                                            Toast.loading(t("加载中"), {
                                                cover: true, // 是否展示透明遮罩层
                                                // coverColor: 'rgba(0, 0, 0, 0)', // 遮罩颜色设定
                                                closeOnClickOverlay: false, // 点击遮罩可关闭
                                                duration: 0
                                            })
                                            if (detailData.model_materials.cutparts && detailData.model_materials.cutparts.length !== 0) {
                                                for (let i = 0; i < detailData.model_materials.cutparts.length; i++) {
                                                    let item = detailData.model_materials.cutparts[i]
                                                    action3D.clearMap(item.code)
                                                }
                                            }
                                            await choiceFabric(v, null, null)
                                            Toast.hide()
                                        }} key={v.color} style={{
                                            width: 20,
                                            height: 20,
                                            background: v.color,
                                            marginTop: 15,
                                            borderRadius: "50%",
                                            border: curFabric.color === v.color ? "solid 1px rgb(245, 119, 102)" : "solid 1px #fff"
                                        }}></div>
                                    ))
                                }
                            </div>
                        }
                    />
                </Drag>
            </div>
            <Context.Provider value={{
                detailData,
                detailAllData,
                curCanvasClient,
                curThreeClient,
                controPosition,
                editMode,
                onEditMode,
                fabricW,
                curCutpartCode,
                fabricClient,
                threeClient,
                menuHeight,
                curActivityObject,
                onSubMenuMode,
                subMenuMode,
                showTitle,
                setShowTitle,
                safeHeigth,
                objectModified,
                preview3D,
                curFabric,
                ossClient,
                setCurEvent,
                curEvent,
                titleChange
            }}>
                <Plugins>
                    <div className="displayAnimate" style={previewMode ? {
                        position: "fixed",
                        ...{ zIndex: 12, background: "linear-gradient(180deg, rgba(238,238,238,1) 0%,  100%)", left: 0, top: 0, bottom: 0, right: 0, margin: "auto" }
                    } : { position: "relative" }}>
                        <canvas className="displayAnimate" ref={canvasRef}></canvas>
                        {
                            previewMode && <Button onClick={quitPreview3D} style={{
                                position: "fixed",
                                bottom: "5%",
                                left: 0,
                                right: 0,
                                margin: "auto",
                                width: 130,
                                backgroundColor: "rgba(0, 0, 0, 0.1)",
                                border: "none", // 去掉边框
                                backdropFilter: "blur(10px)", // 毛玻璃效果（可选）
                                opacity: 1, // 确保元素本身不透明
                                color: "#fff"
                            }} type="primary">{t('退出预览')}</Button>
                        }
                    </div>
                    <Menu action={menuRef} />
                    <Loading progress={progress} />
                    <div ref={safeHeightRef} style={{
                        height: "env(safe-area-inset-bottom)",
                        position: "fixed",
                        zIndex: -1,
                        bottom: 0,
                        left: 0
                    }}></div>
                </Plugins>
            </Context.Provider>
        </div>
    )
}

export default Index
